import {OPTION_CONTAINER_SELECTOR} from './const'
import {setInputAvailability, updateDomAddButton, updateVariantIdInput, swapProductInfo} from './dom'
import {updateCurrentOptions} from './options'
import {updateCurrentVariant} from './variants'
import {ADD_BUTTON_TEXT_UNAVAILABLE_STRING, VARIANTS_JSON_STOCK_SELECTOR} from './const'

async function fetchHTML(endpoint) {
  return await fetch(endpoint)
    .then((response) => response.text())
    .then((responseText) => {
      return new DOMParser().parseFromString(responseText, 'text/html')
    })
}

function compareInputValues() {
  const inputWrappers = Array.from(window.prodify.el.querySelectorAll(OPTION_CONTAINER_SELECTOR))

  inputWrappers.forEach((option, index) => {
    const optionInputs = Array.from(option.querySelectorAll('input[type="radio"], option'))
    const previousOptionSelected = index === 0
      ? null
      : (inputWrappers[index - 1].querySelector(':checked, select') as HTMLInputElement | HTMLSelectElement).value

    const variantsMatchingPreviousOptions = window.prodify.variantData.filter(variant => {
      if (index === 0) return true
      return variant[`option${index}`] === previousOptionSelected
    })

    const availableOptionInputsValues = variantsMatchingPreviousOptions
      .filter(variant => variant.available)
      .map(variant => variant[`option${index + 1}`])

    const existingOptionInputsValues = variantsMatchingPreviousOptions
      .map(variant => variant[`option${index + 1}`])

    setInputAvailability(optionInputs, availableOptionInputsValues, existingOptionInputsValues, index + 1)
  })
}

function initVariantFromUrl() {
  try {
   
    const urlParams = new URLSearchParams(window.location.search)
    const variantId = urlParams.get('variant')
    
    if (!variantId) {
      return false
    }

   
    const targetVariant = window.prodify.variantData.find(
      variant => variant.id.toString() === variantId
    )
    
    if (!targetVariant) {
      console.warn(`Variant ${variantId} not found in product data`)
      return false
    }

   
    preselectVariantInputs(targetVariant)
    
  
    updateCurrentOptions()
    updateCurrentVariant()
    
    
    if (!window.prodify.currentVariant) {
      updateDomAddButton(true, ADD_BUTTON_TEXT_UNAVAILABLE_STRING, true, false)
    } else {
      updateVariantIdInput();
      swapProductInfo();
      updateDomAddButton(false, '', true, false);
      updateBISVisibility();
    }
    
    compareInputValues() 
    
   
    return true
    
  } catch (error) {
    console.error('Error initializing variant from URL:', error)
    return false
  }
}

function preselectVariantInputs(variant) {
  const optionContainers = window.prodify.optionContainers || 
    Array.from(window.prodify.el.querySelectorAll('[data-prodify-option-container]'))

  optionContainers.forEach((container, index) => {
    const optionValue = variant[`option${index + 1}`]
    const pickerType = window.prodify.pickerTypes[`option${index + 1}`]
    
    if (pickerType === 'select') {
     
      const select = container.querySelector('select')
      if (select && optionValue) {
        select.value = optionValue
      }
    } else {
     
      const radio = container.querySelector(`input[value="${optionValue}"]`)
      if (radio) {
        (radio as HTMLInputElement).checked = true
      }
    }
  })
}

function preselectVariantQuantityAvailable() {
  if (new URLSearchParams(window.location.search).get('variant')) return;
    const variantStock = (window as any).variantStock;

    if (!variantStock) return;
  
  const currentVariant = window.prodify.currentVariant;
 
  
  if (currentVariant && variantStock[currentVariant.id.toString()]) return;

  
  const availableVariant = findVariantWithStock(variantStock);
  if (availableVariant) {
    switchToVariant(availableVariant);
  }
}

function shouldShowBISForVariant(variant) {
  const variantStock = (window as any).variantStock
  if (!variantStock) return false
  
  const hasStock = variantStock[variant.id.toString()]
  const inventoryPolicy = variant.inventory_policy || 'deny'
  
  return !hasStock && inventoryPolicy !== 'continue'
}


function findVariantWithStock(variantStock: Record<string, boolean>) {
  const availableVariantId = Object.keys(variantStock).find(id => variantStock[id]);
  return availableVariantId 
    ? window.prodify.variantData?.find(variant => variant.id.toString() === availableVariantId)
    : null;
}


function switchToVariant(targetVariant: any) {
  preselectVariantInputs(targetVariant);
  updateCurrentOptions();
  updateCurrentVariant();
  compareInputValues();
  updateVariantIdInput();
  swapProductInfo();
  updateDomAddButton(false, '', false, false);
  updateBISVisibility();
}

function updateBISVisibility() {
  const bisElement = document.getElementById('BIS_trigger');  
  
  if (bisElement && window.prodify.currentVariant) {
    const currentVariant = window.prodify.currentVariant;
    
    bisElement.setAttribute('data-variant-id', currentVariant.id.toString());
    
    const shouldShow = shouldShowBISForVariant(currentVariant);
    
    bisElement.style.display = shouldShow ? 'block' : 'none';
    
    // Nouvelle ligne : mettre à jour les boutons pickup
    updatePickupButtonsVisibility();
  }
}

function updatePickupButtonsVisibility() {
  const bisElement = document.getElementById('BIS_trigger')
  const upFormButton = document.querySelector('.up_form_product_unavailable')
  const downFormButton = document.querySelector('.down_form_product_unavailable')
  const addToCartButton = document.querySelector('button[name="add"]')
 
  
  if (!bisElement || (!upFormButton && !downFormButton)) return
  
  const isBISVisible = bisElement.style.display !== 'none' && 
                       window.getComputedStyle(bisElement).display !== 'none'
  
  if(addToCartButton){
    if(isBISVisible){
      (addToCartButton as HTMLElement).classList.add('js-full-width');
    }
  }
  
  if (upFormButton) {
    (upFormButton as HTMLElement).style.display = isBISVisible ? 'none' : 'block'
  }
  
  if (downFormButton) {
    (downFormButton as HTMLElement).style.display = isBISVisible ? 'block' : 'none'
  }
}

export {
  fetchHTML,
  compareInputValues,
  initVariantFromUrl,
  preselectVariantInputs,
  preselectVariantQuantityAvailable,
  shouldShowBISForVariant,
  updatePickupButtonsVisibility
}
